import React from "react";
import {
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
  Chip,
  FormControl,
  InputLabel,
  Checkbox,
} from "@mui/material";
import { IWithClassName } from "../../theme/default.theme";
import { IList } from "../../interfaces/default";

interface IProps extends IWithClassName {
  data: Array<IList>;
  onChange: (data: Array<IList>) => void;
  selectedData?: Array<IList>;
  label?: string;
  required?: boolean;
  disable?: boolean;
}

const MultiSeclect = ({
  data,
  onChange,
  selectedData,
  className,
  label,
  required,
  disable,
}: IProps) => {
  const onChangeHandler = ({ target }: SelectChangeEvent<Array<string>>) =>
    onChange(data.filter((item) => target.value.includes(item.id)));

  return (
    <FormControl className={className}>
      {label && (
        <InputLabel htmlFor="multi-select" required={required}>
          {label}
        </InputLabel>
      )}
      <Select
        multiple
        required={!!required}
        id="multi-select"
        disabled={!!disable}
        value={selectedData?.map((item) => item.id)}
        renderValue={() => (
          <>
            {selectedData?.map(({ name }) => (
              <Chip
                variant="outlined"
                label={name}
                onDelete={(e) => {}}
                key={name}
              />
            ))}
          </>
        )}
        onChange={onChangeHandler}
      >
        {data.map((item) => (
          <MenuItem key={item.id} value={item.id} className={className}>
            <Checkbox
              checked={
                !!selectedData?.filter((data) => item.id === data.id).length
              }
              className="item-checkbox"
            />{" "}
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default styled(MultiSeclect)(({ theme }) => ({
  ".MuiChip-root": {
    margin: theme.spacing(0, 0.5),
  },
  ".item-checkbox": {
    padding: theme.spacing(0, 0.5),
  },
}));
